<script>
import { TicketsPath } from "@/path";
import axios from "axios";
import moment from "moment";

export default {
  props: ["ticket_details"],
  data() {
    return {
      base_url: process.env.VUE_APP_API_BACKEND_URL,
      timings: [],
      bank_info: [],
      change_timings: [],
      key: 1,
      days: [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday",
      ],
    };
  },
  watch: {},
  methods: {
    async getTimings() {
      let res = await axios.get(this.base_url + TicketsPath.FETCH_TIMINGS, {
        params: {
          ticket_id: this.ticket_details.id,
        },
      });
      if (res.data.status) {
        res.data.data.forEach((day) => {
          if (day.start_time) {
            if (this.timings[day.day]) {
              this.timings[day.day].push({
                timeslot1: this.convertTo12HourFormat(day.start_time),
                timeslot2: this.convertTo12HourFormat(day.end_time),
              });
            } else {
              this.timings[day.day] = [];
              this.timings[day.day].push({
                timeslot1: this.convertTo12HourFormat(day.start_time),
                timeslot2: this.convertTo12HourFormat(day.end_time),
              });
            }
          }
        });
        this.key += 1;
      }
    },
    async getBankInfo() {
      let res = await axios.get(this.base_url + TicketsPath.FETCH_BANK_INFO, {
        params: {
          ticket_id: this.ticket_details.id,
        },
      });
      if (res.data.status) {
        this.bank_info = res.data.data;
      }
    },
    getNextDate(dateStr, day) {
      const date = new Date(dateStr);

      const daysOfWeek = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ];

      const targetDayIndex = daysOfWeek.indexOf(day);

      date.setDate(date.getDate() + 2);

      while (date.getDay() !== targetDayIndex) {
        date.setDate(date.getDate() + 1);
      }

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const dayOfMonth = String(date.getDate()).padStart(2, "0");

      return `${year}-${month}-${dayOfMonth}`;
    },
    formatDate(v) {
      return moment(v).format("LT");
    },
    convertTo12HourFormat(time) {
      const [hours, minutes] = time.split(":").map(Number);
      const period = hours >= 12 ? "PM" : "AM";
      const formattedHours = hours % 12 === 0 ? 12 : hours % 12;
      const formattedTime = `${String(formattedHours).padStart(
        2,
        "0"
      )}:${String(minutes).padStart(2, "0")} ${period}`;
      return formattedTime;
    },
  },
  mounted() {
    console.log(this.ticket_details, "ticket");
    this.getTimings();
    this.getBankInfo();
  },
};
</script>

<template>
  <b-card>
    <b-card-header
      >Ticket: # {{ ticket_details.ticket_id }}
      <p>
        Priority :
        <b-badge variant="success">{{ ticket_details.priority }}</b-badge>
      </p></b-card-header
    >
    <b-card-body>
      <template
        v-if="ticket_details.extra_details.issue == 'request_for_time_change'"
      >
        <div style="text-transform: capitalize">
          Duration :
          {{ ticket_details.extra_details.applyChanges.split("_").join(" ") }}
        </div>
        <div style="text-transform: capitalize">
          Reason :
          {{ ticket_details.extra_details.description.split("_").join(" ") }}
        </div>
        <div
          style="
            display: flex;
            color: black;
            justify-content: space-between;
            padding-block: 10px;
          "
        >
          <p style="font-size: 18px; padding-bottom: 10px; width: 200px">Day</p>
          <p style="font-size: 18px; padding-bottom: 10px; width: 200px">
            Current Timings
          </p>
          <p style="font-size: 18px; padding-bottom: 10px; width: 200px">
            Requested Timings
          </p>
        </div>
        <div v-for="(day, di) in days" :key="di + key">
          <div
            style="
              display: flex;
              color: black;
              justify-content: space-between;
              border-top: 1px solid gray;
              padding-block: 10px;
            "
          >
            <div style="width: 200px">
              <p style="font-size: 16px">{{ day }}</p>
              <p
                style="font-size: 16px"
                v-if="
                  ticket_details.extra_details.applyChanges ==
                  'for_selected_dates'
                "
              >
                {{ getNextDate(ticket_details.created_at, day) }}
              </p>
            </div>
            <div style="width: 200px">
              <div v-if="timings[day]">
                <div v-for="(slot, i) in timings[day]" :key="i">
                  <div style="display: flex">
                    <div>{{ slot.timeslot1 }}</div>
                    <div>-</div>
                    <div>{{ slot.timeslot2 }}</div>
                  </div>
                </div>
              </div>
              <div v-else>
                <div>Not Operational</div>
              </div>
            </div>
            <div style="width: 200px">
              <div
                v-for="slot in ticket_details.extra_details.timeslots[day]"
                :key="slot"
              >
                <div
                  style="display: flex"
                  v-if="slot.timeslot1 && slot.timeslot2"
                >
                  <div>{{ formatDate(slot.timeslot1) }}</div>
                  <div>-</div>
                  <div>{{ formatDate(slot.timeslot2) }}</div>
                </div>
              </div>
              <div v-if="!ticket_details.extra_details.timeslots[day]"></div>
              <div
                v-if="
                  ticket_details.extra_details.timeslots[day] &&
                  !ticket_details.extra_details.timeslots[day]?.length
                "
              >
                Not Operational
              </div>
            </div>
          </div>
        </div>
      </template>
      <template
        v-if="
          ticket_details.extra_details.issue == 'request_to_change_bank_details'
        "
      >
        <table class="table">
          <thead>
            <tr>
              <th></th>
              <th>Requested Changes</th>
              <th>Current Details</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Account Holder Name</td>
              <td>
                {{ ticket_details.extra_details.bank_info.acc_holder_name }}
              </td>
              <td>{{ bank_info.acc_holder_name }}</td>
            </tr>
            <tr>
              <td>Account Number</td>
              <td>
                {{ ticket_details.extra_details.bank_info.acc_number }}
              </td>
              <td>{{ bank_info.acc_number }}</td>
            </tr>
            <tr>
              <td>Bank Name</td>
              <td>
                {{ ticket_details.extra_details.bank_info.bank_name }}
              </td>
              <td>{{ bank_info.bank_name }}</td>
            </tr>
            <tr>
              <td>IFSC Code</td>
              <td>
                {{ ticket_details.extra_details.bank_info.ifsc_code }}
              </td>
              <td>{{ bank_info.ifsc_code }}</td>
            </tr>
          </tbody>
        </table>
      </template>
    </b-card-body>
  </b-card>
</template>

<style></style>
